const PRICE_FIELDS = ['rabat1_IZN', 'rabat2_IZN', 'rabat3_IZN', 'rabatUkupno_IZN', 'cenaCenovnikBezPDV', 'cenaCenovnikSaPDV', 'krajnjaCenaSaPDV', 'krajnjaCenaBezPDV'];
const hasCompletePricingSnapshot = item => PRICE_FIELDS.every(field => item && item[field] !== null && item[field] !== undefined && String(item[field]).trim() !== '' && Number.isFinite(Number(item[field])));
const copyPricingSnapshot = item => PRICE_FIELDS.reduce((snapshot, field) => {
  snapshot[field] = Number(item[field]);
  return snapshot;
}, {});
const ORDER_ITEM_DISCOUNT_MODE = {
  SEQUENTIAL_SAVED_VALUES: 'sequential-saved-values',
  PRICE_INQUIRY_SNAPSHOT: 'price-inquiry-snapshot'
};
const sequentialSavedValues = _ref => {
  let {
    price,
    discount1 = 0,
    discount2 = 0,
    discount3 = 0,
    taxRate = 0
  } = _ref;
  const base = Number(price);
  const rates = [discount1, discount2, discount3].map(Number);
  const tax = Number(taxRate);
  if (![base, ...rates, tax].every(Number.isFinite)) {
    throw new Error('Invalid saved order item price, discount or tax rate');
  }
  let remaining = base;
  const amounts = rates.map(rate => {
    const amount = remaining * rate / 100;
    remaining -= amount;
    return amount;
  });
  return {
    rabat1_IZN: amounts[0],
    rabat2_IZN: amounts[1],
    rabat3_IZN: amounts[2],
    rabatUkupno_IZN: amounts.reduce((sum, amount) => sum + amount, 0),
    cenaCenovnikBezPDV: base,
    cenaCenovnikSaPDV: base * (1 + tax / 100),
    krajnjaCenaBezPDV: remaining,
    krajnjaCenaSaPDV: remaining * (1 + tax / 100)
  };
};
const PRICING_STRATEGIES = {
  [ORDER_ITEM_DISCOUNT_MODE.SEQUENTIAL_SAVED_VALUES]: sequentialSavedValues
};
const calculatePricingSnapshot = (strategy, inputs) => {
  const calculate = PRICING_STRATEGIES[strategy];
  if (!calculate) {
    throw new Error(`Unsupported pricing strategy: ${strategy}`);
  }
  return calculate(inputs);
};
module.exports = {
  PRICE_FIELDS,
  hasCompletePricingSnapshot,
  copyPricingSnapshot,
  ORDER_ITEM_DISCOUNT_MODE,
  calculatePricingSnapshot
};